import { createElement, type CSSProperties, type JSX } from 'react';

import { iconFromKey } from './icon-map.js';

interface IconFromKeyProps {
  iconKey: string;
  className?: string;
  style?: CSSProperties;
  strokeWidth?: number | string;
  'aria-hidden'?: boolean | 'true' | 'false';
}

/**
 * Render a Lucide icon from its string key. Uses `createElement` directly
 * to avoid the `react-hooks/static-components` rule that fires when the
 * lookup result is bound to a local variable and rendered as JSX.
 */
export function IconFromKey({
  iconKey,
  className,
  ...rest
}: IconFromKeyProps): JSX.Element {
  return createElement(iconFromKey(iconKey), { className, ...rest });
}
